<template>
	<div class="absolute inset-0 flex items-center justify-center">
		<svg
			width="250"
			height="210"
			viewBox="-15 -15 251 210"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g transform="translate(110.5,90)">
				<g>
					<g>
						<animateTransform
							attributeName="transform"
							type="scale"
							values="0.2;1.3;1"
							keyTimes="0;0.7;1"
							dur="0.18s"
							begin="0s"
							fill="freeze"
							repeatCount="1"
						/>
						<animate
							attributeName="opacity"
							values="0;1"
							keyTimes="0;1"
							dur="0.12s"
							begin="0s"
							fill="freeze"
							repeatCount="1"
						/>
						<animateTransform
							attributeName="transform"
							type="scale"
							values="1;0.92;1"
							keyTimes="0;0.5;1"
							dur="0.05s"
							begin="0.2s"
							fill="freeze"
							repeatCount="30"
						/>
						<animateTransform
							attributeName="transform"
							type="scale"
							values="1;1.3;0.2"
							keyTimes="0;0.7;1"
							dur="0.18s"
							begin="1.7s"
							fill="freeze"
							repeatCount="1"
						/>
						<animate
							attributeName="opacity"
							values="1;0"
							keyTimes="0;1"
							dur="0.12s"
							begin="1.7s"
							fill="freeze"
							repeatCount="1"
						/>
						<g transform="translate(-110.5,-90)">
							<path
								d="M160 71.9884L189.274 38.7714L183.336 31.183L220.485 0.96808L197.074 28.9648L202.728 35.9886L160 71.9884Z"
								fill="#EFB248"
							/>
						</g>
					</g>
				</g>
			</g>
			<g transform="translate(110.5,90)">
				<g>
					<animateTransform
						attributeName="transform"
						type="scale"
						values="0.2;1.3;1"
						keyTimes="0;0.7;1"
						dur="0.18s"
						begin="0s"
						fill="freeze"
						repeatCount="1"
					/>
					<animate
						attributeName="opacity"
						values="0;1"
						keyTimes="0;1"
						dur="0.12s"
						begin="0s"
						fill="freeze"
						repeatCount="1"
					/>
					<animateTransform
						attributeName="transform"
						type="scale"
						values="1;0.92;1"
						keyTimes="0;0.5;1"
						dur="0.05s"
						begin="0.18s"
						fill="freeze"
						repeatCount="30"
					/>
					<animateTransform
						attributeName="transform"
						type="scale"
						values="1;1.3;0.2"
						keyTimes="0;0.7;1"
						dur="0.18s"
						begin="1.68s"
						fill="freeze"
						repeatCount="1"
					/>
					<animate
						attributeName="opacity"
						values="1;0"
						keyTimes="0;1"
						dur="0.12s"
						begin="1.68s"
						fill="freeze"
						repeatCount="1"
					/>
					<g transform="translate(-110.5,-90)">
						<path
							d="M31.0822 146.62L57.9542 129.697L30.8455 138.118L21.4935 133.545L-0.000147497 153.145L22.8213 142.061L31.0822 146.62Z"
							fill="#EFB248"
						/>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>
